import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { GeneralNotificationProps } from '@customTypes/PropTypes';
import { I18n } from 'react-redux-i18n';
import exclamationCircle from '../../../../public/svg/notification-alert.svg';
import exclamationTriangle from '../../../../public/svg/notification-warning.svg';
import exclaimationInfo from '../../../../public/svg/notification-info.svg';

const getIconType = (iconType: string) => {
    const type = { info: exclaimationInfo, warning: exclamationTriangle, error: exclamationCircle };
    return type[iconType];
};

const alertStyles: any = {
    info: 'bg-blue-white-variant border-counter-good-border text-hover-color border-b-counter-good-border',
    error: 'bg-counter-ending border-counter-ending-border text-counter-ending-font border- border-b-counter-ending-border',
    warning: 'bg-warning-notification border-counter-warning-border text-counter-warning-font border-b-counter-warning-border',
    success: 'bg-success-background border-success-text text-success-text border-b-success-border',
};

const GeneralNotification = ({
    message = '',
    bold = false,
    type = 'error',
    cta = false,
    ctaPurchase = '',
    ctaLearn = '',
    closeButton = false,
    closeHandler,
    iconType,
}
: GeneralNotificationProps) : JSX.Element => (
    <div className={`flex w-full py-4 border-solid border-b-0.5  items-center justify-between border-b-2 ${alertStyles[type]}`}>
        <div className="flex gap-2">
            {cta && <img className="col-start-1 pl-[15px] md:col-start-1 md:pl-4 mobile:self-baseline" src={getIconType(type)} style={{ width: '24', height: '24' }} alt="alert" />}
            <div className="flex items-center justify-start flex-wrap ">
                {!cta && <img className="col-start-1 pl-[15px] md:col-start-1 md:pl-4 mobile:self-baseline" src={getIconType(type)} style={{ width: '24', height: '24' }} alt="alert" />}
                { !bold ? (<span className="text-black pr-2.5">{message}</span>) : (<span className="text-black pr-2.5"><strong>{message}</strong></span>) }
                { cta && (
                    <div className="text-inherit ">
                        { ctaPurchase ? <a href={ctaPurchase}>Purchase Now</a> : <></> }
                        { ctaLearn ? <a href={ctaLearn} target="_blank" rel="noreferrer" className="underline">{I18n.t('learn-more')}</a> : <></> }
                    </div>
                ) }
            </div>
        </div>
        {/* return ( */}

        { closeButton && (
            <div className="px-3 text-black font-bold">
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={closeHandler} />
            </div>
        )}
    </div>
);

export default GeneralNotification;
